import styled from 'styled-components';

const SecuredFieldContainer = styled.div`
  width: 100%;
  position: relative;
  .eye-icon {
    position: absolute;
    right: 0px;
    top: 15px;
    z-index: 50;
  }
  .Polaris-Connected__Item {
    width: 100%;
  }
  .input-field-container {
    width: 95%;
    padding: 0px 8px;
  }
`;

export { SecuredFieldContainer };
